(function ($) {
const Init = (() => {

  // settings
  
  
  let website       = {},
      load          = {},
      resize        = {},
      resizeW       = {},
      scroll        = {},
      orientation   = {},
      mod           = {},
      anime         = {},
      scrollOption  = {},
      parallax      = {},
      drawer        = {},
      wp            = {},
      slider        = {},
      tab           = {},
      accordion     = {}, 
      cursor        = {},
      pjax          = {},
      iscroll       = {},
      guide         = {},
      page          = {};
      event         = {};  
  
  website = {
    domain: document.domain,
    page: document.body.dataset.page,
    url: document.URL,
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
    scrollY: window.pageYOffset,
    scrollCurrent: 0,
    scrollHeight: 0,
    scrollHiddenHeight: 0,
    scrollRate: 0,
    viewport: document.querySelector('meta[name="viewport"]').getAttribute('content'),
  
    breakpoint: { pc: 1200, tb: 992, sp: 768, ss: 576, min: 375 },
    ua: navigator.userAgent.toLowerCase(),
    entry: performance.getEntriesByType("navigation")[0].type,
    referrer: document.referrer ? new URL(document.referrer) : null,
    isDesktop     : true,
    isTablet      : false,
    isMobile      : false,
    isFirst       : true,
    isTouch       : 'ontouchstart' in window || navigator.maxTouchPoints,
    isReduced     : false,
  
    animationFrame: null,
    headId        : 'js-header',
    footId        : 'js-footer',
  
    load: 'is-load',
    scrolled: 'is-scrolled',
    scrollLock: 'is-scrollLock',
  
    act: 'is-act',
    inact: 'is-inact',
    actView: 'is-view',
    actOpen: 'is-open',
    
    targetAnime: 'js-anime',
    targetAnimeToggle: 'js-animeToggle',
    actAnime: 'is-anime',
    shiftPoint: 0,
    shiftPc: 5,
    shiftSp: 4,
  };
  
  website.shiftPoint = website.breakpoint.tb;
  
  website.headTag = document.getElementById(website.headId);
  website.footTag = document.getElementById(website.footId);
  
  website.isLocal = website.domain === 'localhost' || website.domain === 'xxxxxxx';
  
  load = {
    functions: [],
    length: 0,
  };
  
  resize = {
    functions: [],
    length: 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  resizeW = {
    functions: [],
    length: 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  scroll = {
    functions: [],
    length: 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  orientation = {
    functions: [],
    length: 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  page = {
    common: [],
    home  : [],
  };
  
  
  event = {
    modalOpen: new CustomEvent('modalOpen'),
    modalClose: new CustomEvent('modalClose'),
  }

  //modules
  
  const WinLoad = {
  
    init() {
      window.addEventListener('load', function (e) {
        WinLoad.update();
      });
  
      debug('load init');
    },
  
    add(func) {
      load.functions.push(func);
      load.length = load.functions.length;
    },
  
    remove(func) {
      load.functions.splice(func, 1);
      load.length = load.functions.length;
    },
  
    update() {
      for (let i = 0; i < load.length; i++) {
        let func = load.functions[i];
        func();
      }
    },
  
  }
  
  
  const WinResize = {
  
    init() {
      window.addEventListener('resize', function (e) {
        if (!resize.isRunning) {
          resize.isRunning = true;
  
          resize.animationFrame = window.requestAnimationFrame(WinResize.update);
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinResize.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinResize.update();
          //   }, 1000/resize.fps);
          // }
        }
      });
  
      debug('resize init');
    },
  
    add(func) {
      resize.functions.push(func);
      resize.length = resize.functions.length;
    },
  
    remove(func) {
      resize.functions.splice(func, 1);
      resize.length = resize.functions.length;
    },
  
    update() {
      // website.winWidth = window.innerWidth;
      // website.winHeight = window.innerHeight;
      website.ua = navigator.userAgent.toLowerCase();
  
      for (let i = 0; i < resize.length; i++) {
        let func = resize.functions[i];
        func();
      }
  
      resize.isRunning = false;
    },
  
  }
  
  
  const WinResizeWidth = {
  
    init() {
      window.addEventListener('resize', function (e) {
        if (website.winWidth != window.innerWidth && !resizeW.isRunning) {
          resizeW.isRunning = true;
          resizeW.animationFrame = window.requestAnimationFrame(WinResizeWidth.update);
        }
      });
  
      debug('resizeW init');
    },
  
    add(func) {
      resizeW.functions.push(func);
      resizeW.length = resizeW.functions.length;
    },
  
    remove(func) {
      resizeW.functions.splice(func, 1);
      resizeW.length = resizeW.functions.length;
    },
  
    update() {
      for (let i = 0; i < resizeW.length; i++) {
        let func = resizeW.functions[i];
        func();
      }
  
      resizeW.isRunning = false;
    },
  
  }
  
  
  const WinScroll = {
  
    init() {
      window.addEventListener('scroll', function (e) {
        if (!scroll.isRunning) {
          scroll.isRunning = true;
  
          scroll.animationFrame = window.requestAnimationFrame(WinScroll.update);
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinScroll.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinScroll.update();
          //   }, 1000/scroll.fps);
          // }
        }
      });
  
      debug('scroll init');
    },
  
    add(func) {
      scroll.functions.push(func);
      scroll.length = scroll.functions.length;
    },
  
    remove(func) {
      scroll.functions.splice(func, 1);
      scroll.length = scroll.functions.length;
    },
  
    update() {
      // website.winHeight = window.innerHeight;
      // website.scrollY = window.pageYOffset;
  
      for (let i = 0; i < scroll.length; i++) {
        let func = scroll.functions[i];
        func();
      }
  
      scroll.isRunning = false;
    },
  
  }
  
  
  const OrientationChange = {
  
    init() {
      window.addEventListener('orientationchange', function (e) {
        if (!orientation.isRunning) {
          orientation.isRunning = true;
  
          orientation.animationFrame = window.requestAnimationFrame(OrientationChange.update);
        }
      });
  
      debug('orientationchange init');
    },
  
    add(func) {
      orientation.functions.push(func);
      orientation.length = orientation.functions.length;
    },
  
    remove(func) {
      orientation.functions.splice(func, 1);
      orientation.length = orientation.functions.length;
    },
  
    update() {
      for (let i = 0; i < orientation.length; i++) {
        let func = orientation.functions[i];
        func();
      }
  
      orientation.isRunning = false;
    },
  
  }
  
  
  const Modules = {
    event: {
      init() {
        // settings
        mod = {
          resizeTimer: null,
          deviceCheck: {
            class: {
              ios: 'is-ios',
              sp: 'is-sp',
              tb: 'is-tb',
              pc: 'is-pc',
            }
          },
          smoothScroll: {
            triggerElm: 'js-scroll:not([href=""])',
          },
          reduceMode: {
            class: 'is-reduced'
          }
        };
  
        // run functions
        Modules.event.run();
        
        // set events
        Modules.event.set();
      },
      run() {
        // Modules.func.scrollTopBeforeReload();
        Modules.func.setProperty();
        Modules.func.deviceCheck();
        Modules.func.smoothScroll();
      },
      set() {
        WinLoad.add( Modules.event.load );
        WinResize.add( Modules.event.resize );
        // WinResizeWidth.add( Modules.event.resizeWidth );
        // WinScroll.add( Modules.event.scroll );
        // OrientationChange.add( Modules.event.orientation );
      },
      reset() {
        WinResize.remove( Modules.event.resize );
        // WinResizeWidth.remove( Modules.event.resizeWidth );
        // WinScroll.remove( Modules.event.scroll );
        // OrientationChange.remove( Modules.event.orientation );
      },
      load() {
        Modules.func.reduceMode();
      },
      resize() {
        clearInterval(mod.deviceCheck.resizeTimer);
        mod.resizeTimer = setTimeout(function(){
          Modules.func.setProperty();
          Modules.func.deviceCheck();
          clearInterval(mod.deviceCheck.resizeTimer);
        }, 500);
      },
      resizeWidth() {
      },
      scroll() {
      },
      orientation() {
      },
    },
    func: {
      setProperty() {
        // viewport height
        let vh = website.winHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    
        // scrollbar width 
        let element = document.createElement('div');
        element.style.visibility = 'hidden';
        element.style.overflow = 'scroll';
        document.body.appendChild(element);
        let scrollbarWidth = element.offsetWidth - element.clientWidth;
        document.body.removeChild(element);
        document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
      },
      reduceMode() {
        const videos = document.querySelectorAll('video');
        videos[0].play()
        .then(() => {
  
        })
        .catch(() => {
          website.isReduced = true;
          document.body.classList.add(mod.reduceMode.class);
        });
      },
      deviceCheck() {
        // iOS check
        if (
          !document.body.classList.contains(mod.deviceCheck.class.ios) && 
          ( website.ua.indexOf('ipad') > -1 || 
            website.ua.indexOf('iphone') > -1 || 
            (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
          )
        ) {
          document.body.classList.add(mod.deviceCheck.class.ios);
        } else {
          document.body.classList.remove(mod.deviceCheck.class.ios);
        }
    
        // device check
        if (
          website.ua.indexOf('iphone') > -1 ||
          website.ua.indexOf('ipod') > -1 ||
          website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
        ) {
          website.isDesktop = false;
          website.isTablet = false;
          website.isMobile = true;
          if(!document.body.classList.contains(mod.deviceCheck.class.sp)) {
            document.body.classList.remove(mod.deviceCheck.class.tb,mod.deviceCheck.class.pc);
            document.body.classList.add(mod.deviceCheck.class.sp);
          }
          if( website.winWidth < website.shiftPoint.min ) {
            document.querySelector('meta[name="viewport"]').setAttribute('content', `width=${website.shiftPoint.min}, maximum-scale=2, user-scalable=yes`);
          } else {
            document.querySelector('meta[name="viewport"]').setAttribute('content', website.viewport);
          }
        } else if (
          website.ua.indexOf('ipad') > -1 ||
          website.ua.indexOf('Android') > -1 ||
          (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
        ) {
          website.isDesktop = false;
          website.isTablet = true;
          website.isMobile = false;
          if(!document.body.classList.contains(mod.deviceCheck.class.tb)) {
            document.body.classList.remove(mod.deviceCheck.class.pc,mod.deviceCheck.class.sp);
            document.body.classList.add(mod.deviceCheck.class.tb);
          }
          if( website.tabletView !== false && typeof website.tabletView === 'number' ){
            document.querySelector('meta[name="viewport"]').setAttribute('content', `width=${website.tabletView}, initial-scale=1, maximum-scale=2, user-scalable=yes`);
          }
        } else {
          website.isDesktop = true;
          website.isTablet = false;
          website.isMobile = false;
          if(!document.body.classList.contains(mod.deviceCheck.class.pc)) {
            document.body.classList.remove(mod.deviceCheck.class.tb,mod.deviceCheck.class.sp);
            document.body.classList.add(mod.deviceCheck.class.pc);
          }
        }
      },
      smoothScroll() {
        if( typeof Iscroll === "undefined" ) {
          $(document).on('click', `.${mod.smoothScroll.triggerElm}`, function(e){ 
            const href = $(this).attr("href"),
                  target = $((href == "#") ? 'html' : href);
            let position = target.offset().top;
  
            if( website.headTag.style.position == 'fixed' ) {
              const shift = Common.func.getHeaderHeight();
              position = target.offset().top - shift;
            }
  
            window.scrollTo({
              top: position,
              behavior: 'smooth'
            });
  
            return false;
          });
        }
      },
      scrollTopBeforeReload() {
        window.addEventListener("beforeunload",function(){
          window.scrollTo(0, 0);
        });
      },
    },
  }
  
  
  const Animation = {
    event: {
      init() {
        // run functions
        Animation.event.run();
  
        // set events
        Animation.event.set();
      },
      run() {
        Animation.func.check();
      },
      set() {
        // WinLoad.add( DrawerMenu.event.load );
        // WinResize.add( DrawerMenu.event.resize );
        // WinResizeWidth.add( DrawerMenu.event.resizeWidth );
        WinScroll.add( Animation.event.scroll );
        // OrientationChange.add( DrawerMenu.event.orientation );
      },
      reset() {
        // WinResize.remove( DrawerMenu.event.resize );
        // WinResizeWidth.remove( DrawerMenu.event.resizeWidth );
        WinScroll.remove( Animation.event.scroll );
        // OrientationChange.remove( DrawerMenu.event.orientation );
      },
      load() {
      },
      resize() {
      },
      resizeWidth() {
      },
      scroll() {
        Animation.func.check();
        Animation.func.toggle();
      },
      orientation() {
      },
    },
    func: {
      check() {
        $(`.${website.targetAnime}:not(.${website.actAnime})`).each(function () {
          const self = $(this),
                position = self.offset().top;
          let shift, threshold;
  
          if (website.winWidth < website.shiftPoint) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
  
          threshold = position - website.winHeight + shift;
  
          if(position < website.winHeight) {
            if (typeof self.data('delay') !== 'undefined') {
              self.css('transitionDelay', self.data('delay') + 'ms')
            }
            self.addClass(website.actAnime);
          } else if( website.scrollY > threshold) {
            if (typeof self.data('delay') !== 'undefined') {
              self.css('transitionDelay', self.data('delay') + 'ms')
            }
            self.addClass(website.actAnime)
          }
        });
      },
      toggle() {
        $(`.${website.targetAnimeToggle}`).each(function() {
          const self = $(this);
          const offset = {top: parseInt(self.css('padding-top')), bottom: parseInt(self.css('padding-bottom'))};
          const top = self.offset().top, bottom = top + self.outerHeight();
          if( website.scrollY + website.winHeight - offset.top > top && website.scrollY + offset.bottom < bottom ) {
            self.addClass(website.actAnime);
          } else {
            self.removeClass(website.actAnime);
          }
        });
      },
      reset() {
        $(`.${website.targetAnime+website.actAnime}`).removeClass(website.actAnime);
        $(`.${website.targetAnimeToggle+website.actAnime}`).removeClass(website.actAnime);
      }
    }
  }
  
  
  const Modal = {
    event: {
      init() {
        // settings
        modal = {
          targetElm: 'js-modal',
          openElm: 'js-modalOpen',
          closeElm: 'js-modalClose',
          overlayElm: 'js-modalOverlay',
        };
  
        // run functions
        Modal.event.run();
  
        // set events
        Modal.event.set();
      },
      run() {
        Modal.func.open();
        Modal.func.close();
      },
      set() {
        // WinLoad.add( Modal.event.load );
        // WinResize.add( Modal.event.resize );
        // WinResizeWidth.add( Modal.event.resizeWidth );
        // WinScroll.add( Modal.event.scroll );
        // OrientationChange.add( Modal.event.orientation );
      },
      reset() {
        // WinResize.remove( Modal.event.resize );
        // WinResizeWidth.remove( Modal.event.resizeWidth );
        // WinScroll.remove( Modal.event.scroll );
        // OrientationChange.remove( Modal.event.orientation );
      },
      load() {
      },
      resize() {
      },
      resizeWidth() {
      },
      scroll() {
      },
      orientation() {
      },
    },
    func: {
      open() {
        $(document).on('click', `.${modal.openElm}`, function () {
          document.dispatchEvent(event.modalOpen);
          const id = $(this).attr('href');
          const targetElm = $(`.${modal.targetElm + id}`);
          const speed = targetElm.data('speed');
          $('html').addClass(website.scrollLock);
          targetElm.fadeIn(speed, function() {
            $(this).addClass(website.actOpen);
          });
          if( typeof Iscroll !== "undefined" ) {
            Iscroll.stop();
          }
          return false;
        });
      },
      close() {
        $(document).on('click', `.${modal.closeElm}, .${modal.overlayElm}`, function () {
          document.dispatchEvent(event.modalClose);
          const targetElm = $(this).closest(`.${modal.targetElm}`);
          const speed = targetElm.data('speed');
  
          targetElm.removeClass(function() {
            return website.actOpen;
          });
          targetElm.fadeOut(speed, function() {
            $('html').removeClass(website.scrollLock);
            if($(this).closest(`.${modal.targetElm}`).find('video').length) {
              $(this).closest(`.${modal.targetElm}`).find('video').get(0).pause();
            }
            if($(this).closest(`.${modal.targetElm}`).find('iframe').length) {
              $(this).closest(`.${modal.targetElm}`).find('iframe').each(function(){
                if($(this).attr('src').indexOf('youtube') > -1 && $(this).attr('src').indexOf('enablejsapi=1') > -1) {
                  const message = '{"event": "command", "func": "stopVideo", "args": ""}';
                  $(this)[0].contentWindow.postMessage(message, '*');
                }
              });
            }
          });
          if( typeof Iscroll !== "undefined" ) {
            Iscroll.start();
          }
        });
      }
    },
  }
  const Slider = {
    event: {
      init() {
        // settings
        slider =  {
          gallery: {
            wrapperElm: 'js-splideGallery',
            sliderElm: 'js-splideGalleryMain',
            thumbElm: 'js-splideGalleryThumb',
            options: {
              type: 'loop',
              arrows: true,
              pagination: true,
              autoplay   : false,
              pauseOnHover: true,
              pauseOnFocus: true,
              reducedMotion: {
                speed      : 400,
                rewindSpeed: 400,
                autoplay   : false,
              },
            }
          },
          basic: {
            sliderElm: 'js-splideBasic', 
            options: {
              type: 'slide',
              gap: 13,
              perPage: 6,
              perMove: 1,
              arrows: true,
              pagination: false,
              pauseOnHover: true,
              pauseOnFocus: true,
              breakpoints: {
                1280:  {
                  gap: 15,
                  perPage: 5,
                },
                979: {
                  perPage: 1,
                  autoWidth: true,
                }
              },
              reducedMotion: {
                speed      : 400,
                rewindSpeed: 400,
                autoplay   : false,
              }
            }
          },
          marquee: {
            sliderElm: 'js-splideMarquee',
            options: {
              type: 'loop',
              focus: 'center',
              autoWidth: true,
              pagination: false,
              drag: false,
              arrows: false,
              autoScroll: {
                speed: 1,
                autostart: false,
                pauseOnHover: false,
                pauseOnFocus: false,
              },
            }
          }
        };
  
        // run functions 
        Slider.event.run();
  
        // set events
        Slider.event.set();
      },
      run() {
        // Slider.func.basic();
        // Slider.func.gallery();
        Slider.func.marquee();
      },
      set() {
        // WinLoad.add( Slider.event.load );
        // WinResize.add( Slider.event.resize );
        // WinResizeWidth.add( Slider.event.resizeWidth );
        // WinScroll.add( Slider.event.scroll );
        // OrientationChange.add( Slider.event.orientation );
      },
      reset() {
        // WinLoad.remove( Slider.event.load );
        // WinResize.remove( Slider.event.resize );
        // WinResizeWidth.remove( Slider.event.resizeWidth );
        // WinScroll.remove( Slider.event.scroll );
        // OrientationChange.remove( Slider.event.orientation );
      },
      load() {
  
      },
      resize() {
  
      },
      resizeWidth() {
  
      },
      scroll() {
  
      },
      orientation() {
  
      },
    },
    func: {
      basic() {
        const sliderElms = document.getElementsByClassName(slider.basic.sliderElm);
        const sliderNums = sliderElms.length;
        if(sliderNums) {
          for(let i = 0; i < sliderNums; i++) {
            const sliderElm = sliderElms[i];
            const sliderInst = new Splide(sliderElm, slider.basic.options);
            sliderInst.mount();
          }
        }
      },
      gallery() {
        const sliderElms = document.getElementsByClassName(slider.gallery.wrapperElm);
        const sliderNums = sliderElms.length;
        if(sliderNums) {
          for(let i = 0; i < sliderNums; i++) {
            const sliderElm = sliderElms[i].getElementsByClassName(slider.gallery.sliderElm)[0];
            const sliderInst = new Splide(sliderElm, slider.gallery.options);
            const thumbElms = sliderElms[i].getElementsByClassName(slider.gallery.thumbElm);
            const thumbNums = thumbElms.length;
            sliderInst.on('mounted', () => {
              const thumbStart = thumbElms[sliderInst.index];
              thumbStart.classList.add('is-active');
              for(let i = 0; i < thumbNums; i++) {
                thumbElms[i].setAttribute('aria-label',`Go to slide ${i+1}`);
                thumbElms[i].addEventListener('click', function() {
                  sliderInst.go(i);
                });
              }
            });
            sliderInst.on('move', (newIndex,prevIndex,destIndex) => {
              thumbElms[prevIndex].classList.remove('is-active');
              thumbElms[newIndex].classList.add('is-active');
            });
            sliderInst.mount();
          }
        }
      },
      marquee() {
        const sliderElms = document.getElementsByClassName(slider.marquee.sliderElm);
        const sliderNums = sliderElms.length;
        if(sliderNums) {
          for(let i = 0; i < sliderNums; i++) {
            const sliderElm = sliderElms[i];
            const sliderInst = new Splide(sliderElm, slider.marquee.options);
            sliderInst.mount(window.splide.Extensions);
          }
        }
      }
    }
  }

  // ./inc/_wordpress.js
  // ./inc/_cursor.js
  // ./inc/_pjax.js
  // ./inc/_iscroll.js
  // ./inc/_drawermenu.js
  // ./inc/_accordion.js
  // ./inc/_tab.js

  // page
  const Common = {
    event: {
      init() {
        // settings
        page.common = {
          header: {
            adjust: {
              checkClass: 'js-headerAdjustCheck',
              threshold: 100,
              toggleClass: 'is-adjust',
            },
            view: {
              checkClass: 'js-headerViewCheck',
              threshold: 100,
              toggleClass: 'is-view',
              scrollCurrent: 0,
            },
          },
          megamenu: {
            triggerElm: 'js-megamenu',
            wrapperElm: 'js-megamenuWrapper',
            speed: 200,
          },
          scrollHint: {
            wrapperElm: 'js-scrollHint',
            iconElm: 'js-scrollHintIcon',
            targetElm: 'js-scrollHintTarget',
            threshold: 10,
          },
        };
  
        // run functions
        Common.event.run();
        // set events
        Common.event.set();
      },
      run() {
        Common.func.headerAdjust();
        Common.func.headerScrollUpView();
        Common.func.megamenuInit();
        Common.func.scrollHint();
      },
      set() {
        WinLoad.add( Common.event.load );
        WinResize.add( Common.event.resize );
        // WinResizeWidth.add( Common.event.resizeWidth );
        WinScroll.add( Common.event.scroll );
        // OrientationChange.add( Common.event.orientation );
      },
      reset() {
        WinResize.remove( Common.event.resize );
        // WinResizeWidth.remove( Common.event.resizeWidth );
        WinScroll.remove( Common.event.scroll );
        // OrientationChange.remove( Common.event.orientation );
      },
      load() {
        Common.func.loaded();
        Common.func.scrolled();
      },
      resize() {
        Common.func.headerAdjust();
        Common.func.headerScrollUpView();
      },
      resizeWidth() {
      },
      scroll() {
        Common.func.scrolled();
        Common.func.headerAdjust();
        Common.func.headerScrollUpView();
      },
      orientation() {
      },
    },
    func: {
      loaded() {
        document.documentElement.classList.add(website.load);
      },
      scrolled() {
        if(website.scrollY > 0) {
          document.documentElement.classList.add(website.scrolled);
        } else {
          document.documentElement.classList.remove(website.scrolled);
        }
      },
      headerAdjust() {
        if( website.headTag.classList.contains(page.common.header.adjust.checkClass) ) {
          if( website.headTag.classList.contains(page.common.header.adjust.toggleClass) && website.scrollY < page.common.header.adjust.threshold ) {
            website.headTag.classList.remove(page.common.header.adjust.toggleClass);
          } else if( !website.headTag.classList.contains(page.common.header.adjust.toggleClass) && website.scrollY >= page.common.header.adjust.threshold ) {
            website.headTag.classList.add(page.common.header.adjust.toggleClass);
          }
        }
      },
      headerScrollUpView() {
        if( website.headTag.classList.contains(page.common.header.view.checkClass) ) {
          if( website.scrollY === page.common.header.view.scrollCurrent ) {
            return;
          }
  
          if( !website.headTag.classList.contains(page.common.header.view.toggleClass) && (website.scrollY <= page.common.header.threshold || website.scrollY < page.common.header.view.scrollCurrent) ) {
            website.headTag.classList.add(page.common.header.view.toggleClass);
          } else if( website.headTag.classList.contains(page.common.header.view.toggleClass) && website.scrollY > 10 && page.common.header.threshold > page.common.header.view.scrollCurrent ) {
            website.headTag.classList.remove(page.common.header.view.toggleClass);
          }
        }
      },
      getHeaderHeight() {
        let headerHeight;
        if( website.headTag.classList.contains(page.common.header.adjust.checkClass) ) {
          const cloneHeader = website.headTag.cloneNode(true),
                cloneId = 'js-headerClone';
          cloneHeader.classList.add(page.common.header.adjust.toggleClass);
          cloneHeader.style.visibility = 'hidden';
          cloneHeader.style.position = 'absolute';
          cloneHeader.style.top = '0';
          cloneHeader.style.left = '0';
          cloneHeader.style.width = '100%';
          cloneHeader.style.zIndex = '-1';
          cloneHeader.id = cloneId;
          document.body.appendChild(cloneHeader);
          headerHeight = cloneHeader.clientHeight;
          document.getElementById(cloneId).remove();
        } else {
          headerHeight = website.headTag.clientHeight;
        }
        return headerHeight;
      },
      megamenuInit() {
        if(website.isDesktop) {
          $(document).on('mouseenter', `.${page.common.megamenu.triggerElm}`, function () {
            $(this).addClass(website.act);
            $(this).children(`.${page.common.megamenu.wrapperElm}`).stop().slideDown(page.common.megamenu.speed).addClass(website.act);
            $('html').addClass(website.scrollLock);
          }).on('mouseleave', `.${page.common.megamenu.triggerElm}`, function () {
            $(this).removeClass(website.act);
            $(this).children(`.${page.common.megamenu.wrapperElm}`).stop().slideUp(page.common.megamenu.speed).removeClass(website.act);
            $('html').removeClass(website.scrollLock);
          });
        } else {
          $(document).on('click', `.${page.common.megamenu.triggerElm} a`, function () {
            if( $(this).closest(`.${page.common.megamenu.triggerElm}`).hasClass(website.act) ) {
              $(this).closest(`.${page.common.megamenu.triggerElm}`).removeClass(website.act);
              $(this).siblings(`.${page.common.megamenu.wrapperElm}`).stop().slideUp(page.common.megamenu.speed).removeClass(website.act);
              $('html').removeClass(website.scrollLock);
            } else {
              $(this).closest(`.${page.common.megamenu.triggerElm}`).addClass(website.act);
              $(this).siblings(`.${page.common.megamenu.wrapperElm}`).stop().slideDown(page.common.megamenu.speed).addClass(website.act);
              $('html').addClass(website.scrollLock);
            }
          });
        }
      },
      megamenuClose() {
        $('html').removeClass(website.scrollLock);
        $(`.${page.common.megamenu.triggerElm}`).removeClass(website.act);
        $(`.${page.common.megamenu.wrapperElm}`).removeClass(website.act);
        $(`.${page.common.megamenu.wrapperElm}`).hide();
      },
      scrollHint() {
        const targetElms = document.getElementsByClassName(page.common.scrollHint.targetElm);
        if( targetElms.length === 0 ) return;
        targetElms.forEach((elm) => {
          const targetElm = elm.getElementsByClassName(page.common.scrollHint.targetElm)[0];
          const iconElm = elm.getElementsByClassName(page.common.scrollHint.iconElm)[0];
          targetElm.addEventListener('scroll', function() {
            if(targetElm.scrollLeft > page.common.scrollHint.threshold) {
              iconElm.classList.add(website.inact);
            }
          })
        });
      },
    },
  }
  
  // ./page/_home.js


  // debug
  const debug = (value) => {
    if(website.isLocal) {
      if(typeof value === 'string') {
        console.log(`!--  ${value} --!`)
      } else {
        console.log(value);
      }
    }
  }

  // application
  const App = {

    init() {
      if (website.page != 'wp-manual' && website.page != 'wp-manual-single') {
        this.set();
        this.update();
      } else {
        if(Wordpress) {
          Wordpress.init();
        }
      }
    },
    run() {
      debug('app init');
      Modules.event.init();
      if( typeof Common !== 'undefined' ) {
        Common.event.init();
      }
      if( typeof DrawerMenu !== 'undefined' ) {
        DrawerMenu.event.init();
      }
      if( typeof Accordion !== 'undefined' ) {
        Accordion.event.init();
      }
      if( typeof Tab !== 'undefined' ) {
        Tab.event.init();
      }
      if( typeof Modal !== 'undefined' ) {
        Modal.event.init();
      }
      if( typeof Animation !== 'undefined' ) {
        Animation.event.init();
      }
      if( typeof Slider !== 'undefined' ) {
        Slider.event.init();
      }
    },
    set() {
      if(typeof Pjax === 'undefined') {
        App.run();
      } else {
        Pjax.event.init();
      }


      WinLoad.init();
      WinResize.init();
      WinResizeWidth.init();
      WinScroll.init();
      OrientationChange.init();

    },

    update() {
      website.animationFrame = window.requestAnimationFrame(App.update);

      website.winWidth = window.innerWidth;
      website.winHeight = window.innerHeight;
      website.scrollY = window.pageYOffset;

      website.scrollHeight = document.documentElement.scrollHeight;
      website.scrollHiddenHeight = website.scrollHeight - website.winHeight;
      website.scrollRate = Math.round((website.scrollY / website.scrollHiddenHeight) * 100);

      // if (website.isDesktop) {
      //   PageScroll.smooth();

      //   if (mod.cursorMagnet) {
      //     Modules.cursorMagnet();
      //   }

      //   if (website.page == 'top') {
      //     Parallax.deviateScroll();
      //   }
      // }
    },

  }


  App.init();

})();


})(jQuery);
